module.exports = __webpack_public_path__ + "media/images/jumping/ing-da38f90c2388d5192d8491fbb5db8ba3.png";